<template>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <div>
        <a href="#" class="text-secondary text-decoration-none" @click="isSearchVisible = !isSearchVisible">
          <i class="fas fa-search"></i>
          <span v-show="isSearchVisible" @click="FilterParkings()">Zamknij wyszukiwanie</span>
          <span v-show="!isSearchVisible">Szukaj</span>
        </a>
        <div v-show="isSearchVisible">
          <input v-model="searchText" type="search" class="form-control" placeholder="Wyszukaj w panelu" @input="FilterParkings">
        </div>
      </div>
      <RefreshButton :refreshing="refreshing"/>
    </div>
    <hr>
    <div class="row">
      <div class="d-lg-flex justify-content-between">
        <h5 class="fw-bold">
          PARKINGI
        </h5>
        <router-link class="btn btn-primary" :to="{ name: 'CreateParking' }">
          Dodaj nowy parking
        </router-link>
      </div>
    </div>
    <table class="table table-responsive overflow-scroll mt-3" style="min-width: 1200px;">
      <thead>
        <tr>
          <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
            Nazwa parkingu
          </td>
          <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
            Opis
          </td>
          <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
            Adres
          </td>
          <td class="bg-light p-2 rounded border border-white" style="width: 100px;">
            Akcje
          </td>
        </tr>
      </thead>
      <tr v-for="parking in parkings" :key="parking.id" style="border-top: 0px black solid">
        <td class="" style="width: 200px;">
          {{ parking.name }} <span v-if="parking.hidden"> (ukryty) </span>
        </td>
        <td class="" style="width: 200px;">
          {{ parking.description }}
        </td>
        <td class="" style="width: 200px;">
          {{ parking.address }}
        </td>
        <td class="" style="width: 100px;">
          <div>
            <button class="btn btn-danger" style="margin-right: 5px" @click="DeleteParking(parking.id)">
              Usuń
            </button>
            <router-link :to="{name: 'EditParking', params: {id: parking.id}}" class="btn btn-primary">
              Edytuj
            </router-link>
            <button class="m-2 btn btn-success" @click="ChangeParkingHidden(true, parking)" v-if="!parking.hidden">
              Ukryj
            </button>

            <button class="m-2 btn btn-success" @click="ChangeParkingHidden(false, parking)" v-else>
              Wyłącz ukrywanie
            </button>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import axios from 'axios'
import Swal from 'sweetalert2'
import RefreshButton from '@/components/Layout/RefreshButton.vue'
import emitter from '@/modules/events/emitter'
export default {
  components: {
    RefreshButton,
    Navbar
  },
  data () {
    return {
      parkings: [],
      allParkings: [],
      searchText: '',
      refreshing: false
    }
  },
  created () {
    emitter.on('refreshed', this.refresh)
  },
  mounted () {
    this.fetchParkings()
  },
  methods: {
    refresh () {
      this.fetchParkings()
    },

    fetchParkings () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      this.refreshing = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}Parking`, config)
        .then((response) => { this.parkings = response.data; this.allParkings = response.data }).catch((e) => { console.log(e) }).finally(() => this.refreshing = false)
    },
    DeleteParking (id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.delete(`${process.env.VUE_APP_API_BASE_URL}Parking/${id}`,config)
        .then((response) => {
          Swal.fire('Sukces', 'Pomyślnie usunięto parking', 'success')
          this.fetchParkings()
        })
    },
    FilterParkings () {
      const searchText = this.searchText
      this.parkings = this.allParkings.filter(function (parking) {
        return parking.name.match(searchText)
      })
    },
    ChangeParkingHidden (bool, parking) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const putData = {
        hidden: bool
      }
      parking.hidden = bool

      axios.put(`${process.env.VUE_APP_API_BASE_URL}Parking/${parking.id}`, putData, config).then(() => {
        Swal.fire('Sukces', 'Pomyślnie wykonano akcję.', 'success')
      })
    }
  }

}
</script>

<style>
</style>
